import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
  static displayName = Layout.name;

  render () {
    return (
        <div>
            <NavMenu />
            {/*  fluid with a cap in custom.css rather than the default .container, whose
                 1140px max-width at xl left the data tables overflowing while the screen
                 sat empty either side. */}
            <Container fluid className="app-container">
                {this.props.children}
            </Container>
      </div>
    );
  }
}
